import { render, staticRenderFns } from "./legalCenter.vue?vue&type=template&id=3e8ec475&scoped=true&"
import script from "./legalCenter.vue?vue&type=script&lang=js&"
export * from "./legalCenter.vue?vue&type=script&lang=js&"
import style0 from "./legalCenter.vue?vue&type=style&index=0&id=3e8ec475&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ec475",
  null
  
)

export default component.exports